import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6e4da3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OTabelaUsuariosAtivos__InformacoesPessoais",
  "data-testid": "OTabelaUsuariosAtivos__Dado"
}
const _hoisted_2 = { class: "OTabelaUsuariosAtivos__NomeEmail" }
const _hoisted_3 = { class: "OTabelaUsuariosAtivos__Nome quebrar-texto-em-duas-linhas" }
const _hoisted_4 = { class: "OTabelaUsuariosAtivos__Email" }
const _hoisted_5 = { class: "ajustar-textos-longos" }
const _hoisted_6 = { class: "OTabelaUsuarios__GrupoDeBotoes" }

import { ref } from "vue"
  import { ListarUsuarios } from "@/repositorios/usuarios/usuarios.modelo"
  import router from "@/router"

  import Column from "primevue/column"
  import DataTable, {
    DataTableFilterMeta,
    DataTableFilterMetaData,
  } from "primevue/datatable"
  import PButton from "primevue/button"
  import {
    MInput,
    MMultiSelect,
    AEstadoVazioTabela,
  } from "@/components/Gerais"
  import Chip from "primevue/chip"

  import Avatar from "primevue/avatar"
  import { ODetalhesUsuario } from "@/components/Usuarios"
  import { DadosModal } from "../index.interface"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"

  import Paginator, { PageState } from "primevue/paginator"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import { FilterMatchMode, FilterOperator } from "primevue/api"
  import { EntidadeGenerica } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    carregandoLista: boolean
    usuariosAtivos: ListarUsuarios[]
    primeiraPagina: number
    itensPorPagina: number
    totalDeResultados: number
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaUsuariosAtivos',
  props: {
    carregandoLista: { type: Boolean },
    usuariosAtivos: null,
    primeiraPagina: null,
    itensPorPagina: null,
    totalDeResultados: null
  },
  emits: ["exibirModalDesativarUsuario", "paginarUsuariosAtivos", "filtrarUsuariosAtivos", "limparFiltros"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "exibirModalDesativarUsuario", valor: DadosModal)
    (event: "paginarUsuariosAtivos", valor: { page: number; rows: number })
    (event: "filtrarUsuariosAtivos", valor: Record<string, string>)
    (event: "limparFiltros", valor: Record<string, string>)
  }), expose: any, slots: any, attrs: any }) {

  
  

  const { t } = useI18n()

  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 270px)"
  const OPCOES_DE_ITENS_POR_PAGINA = [5, 10, 20, 30]

  const filtros = ref<DataTableFilterMeta | undefined>({
    email: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    codigo: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },

    perfil_de_organizacao: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.IN },
      ] as DataTableFilterMetaData[],
    },
  })

  const {
    filtros: filtrosComposable,
    preencherFiltro,
    removerFiltro,
  } = usarFiltragem()
  const { pegarIniciais } = usarFuncoesStrings()

  const perfisDeOrganizacaoOpcoes = ref<EntidadeGenerica[]>([
    {
      id: "administrador",
      nome: t("administrador"),
    },
    {
      id: "supervisor",
      nome: t("supervisor"),
    },
    {
      id: "gerente",
      nome: t("gerente"),
    },

    {
      id: "pessoal",
      nome: t("pessoal"),
    },
    {
      id: "visualizador",
      nome: t("visualizador"),
    },
  ])

  const perfisDeOrganizacaoComInternacionalizacao = {
    administrador: t("administrador"),
    supervisor: t("supervisor"),
    gerente: t("gerente"),

    pessoal: t("pessoal"),
    visualizador: t("visualizador"),
  }

  const aplicarInternacionalizacao = (usuario: ListarUsuarios) => {
    const { perfilDeOrganizacao } = usuario

    return perfisDeOrganizacaoComInternacionalizacao[perfilDeOrganizacao]
  }


  const desativarLinhaPorStatus = (data: any): string | undefined => {
    return !data.status ? "row-disabled" : undefined
  }

  const estilizarLabelAvatar = (label: string, avatar: string) => {
    if (avatar) {
      return undefined
    } else {
      return pegarIniciais(label)
    }
  }

  const exibirModal = (id: string, nome: string) => {
    const informacoesModal: DadosModal = {
      id,
      nome,
      acao: "desativar",
      legenda: t("umUsuarioDesativadoNaoPoderaMaisSerUtilizado"),
      modalEstaAberto: true
    }
    emitir("exibirModalDesativarUsuario", informacoesModal)
  }

  const editarUsuario = async (usuario) => {
    const idUsuario = usuario.id as string
    router.push(`/usuarios/editar-usuario/${idUsuario}`)
  }

  const onPaginarUsuariosAtivos = ({ page, rows }: PageState) => {
    emitir("paginarUsuariosAtivos", { page, rows })
  }

  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro,
    nomeDaColunaNaAPI
  ) => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]

    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)
    emitir("filtrarUsuariosAtivos", filtrosComposable.value)
  }

  const limparFiltros = async (nome, filterCallback) => {
    removerFiltro(nome)
    filterCallback()
    emitir("limparFiltros", filtrosComposable.value)
  }

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_permissionamento = _resolveDirective("permissionamento")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: filtros.value,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filtros).value = $event)),
    class: "OTabelaUsuarios p-datatable-sm",
    "data-key": "id",
    "data-testid": "OTabelaUsuariosAtivos",
    "filter-display": "menu",
    "global-filters-fields": [
      'nome',
      'id',
      'responsaveis',
      'perfil_de_organizacao',
    ],
    loading: __props.carregandoLista,
    "responsive-layout": "scroll",
    "row-class": desativarLinhaPorStatus,
    rows: 5,
    "scroll-height": ALTURA_RELATIVA_DA_TABELA,
    scrollable: "",
    "striped-rows:value": "usuariosAtivos",
    value: __props.usuariosAtivos
  }, _createSlots({
    loading: _withCtx(() => [
      _createVNode(_component_Skeleton, {
        height: "100%",
        width: "100%"
      })
    ]),
    expansion: _withCtx(({ data }) => [
      _createVNode(_unref(ODetalhesUsuario), {
        "id-responsavel": data.id
      }, null, 8, ["id-responsavel"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Paginator), {
        onPage: onPaginarUsuariosAtivos,
        "current-page-report-template": "{first}-{last} de {totalRecords}",
        "data-testid": "OTabelaUsuariosAtivos__Paginator",
        first: __props.primeiraPagina,
        rows: __props.itensPorPagina,
        "rows-per-page-options": OPCOES_DE_ITENS_POR_PAGINA,
        template: "FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown",
        "total-records": __props.totalDeResultados
      }, null, 8, ["first", "rows", "total-records"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column",
        field: "nome",
        header: _unref(t)('nome'),
        "show-add-button": false,
        "show-filter-match-modes": false,
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Avatar), {
              class: "OTabelaUsuariosAtivos__Avatar",
              image: data.fotoDeAvatar,
              label: estilizarLabelAvatar(data.nome, data.fotoDeAvatar),
              shape: "circle"
            }, null, 8, ["image", "label"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(data.nome), 1),
              _createElementVNode("small", _hoisted_4, _toDisplayString(data.email), 1)
            ])
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-nome-do-usuario",
            placeholder: _unref(t)('pesquisarPorNomeDoUsuario'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column",
        field: "codigo",
        header: _unref(t)('codigo'),
        "show-add-button": false,
        "show-filter-operator": false
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(data.codigo), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-codigo",
            placeholder: _unref(t)('pesquisarporCodigo'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column",
        "data-type": "multiselect",
        field: "perfil_de_organizacao",
        header: _unref(t)('perfilDeOrganizacao'),
        "show-add-button": false,
        "show-filter-match-modes": false,
        "show-filter-operator": false
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_unref(Chip), {
            class: "OTabelaUsuarios__PerfilDeOrganizacao",
            label: aplicarInternacionalizacao(data)
          }, null, 8, ["label"])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MMultiSelect), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "OAcordeaoProjetos__MMultiselect",
            "exibicao-de-opcoes": "comma",
            filter: true,
            "maximo-de-legendas-selecionadas": 3,
            nome: "filtro-perfis-de-operacao",
            "option-label": "nome",
            "option-value": "id",
            options: perfisDeOrganizacaoOpcoes.value,
            placeholder: _unref(t)('pesquisarPorPerfisDeOperacao')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaUsuarios__Column OTabelaUsuarios__Actions",
        field: "acoes",
        header: "",
        "show-add-button": false,
        "show-filter-operator": false,
        style: {"flex":"0"}
      }, {
        body: _withCtx(({ data: usuario }) => [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createVNode(_unref(PButton), {
              onClick: ($event: any) => (editarUsuario(usuario)),
              class: "OTabelaUsuarios__IButton p-button-rounded",
              "data-testid": "OTabelaUsuarios__IButton",
              icon: "pi pi-pencil"
            }, null, 8, ["onClick"]), [
              [_directive_permissionamento, { operacao: 'editar' }, "Usuarios"],
              [
                _directive_tooltip,
                _unref(t)('editar'),
                void 0,
                { top: true }
              ]
            ]),
            _withDirectives(_createVNode(_unref(PButton), {
              onClick: ($event: any) => (exibirModal(usuario.id, usuario.nome)),
              class: "OTabelaUsuarios__IButton p-button-rounded",
              "data-testid": "OTabelaUsuarios__DesativarUsuario",
              icon: "pi pi-user-minus"
            }, null, 8, ["onClick"]), [
              [
                _directive_permissionamento,
                {
              operacao: 'desativar',
              recurso: { id: usuario.id },
            },
                "Usuarios",
                { intriseca: true }
              ],
              [
                _directive_tooltip,
                _unref(t)('desativar'),
                void 0,
                { top: true }
              ]
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!__props.carregandoLista)
      ? {
          name: "empty",
          fn: _withCtx(() => [
            _createVNode(_unref(AEstadoVazioTabela))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["filters", "loading", "value"]))
}
}

})